export function str2bool(_value, _default = false) {
    // helper function to evaluate given value to boolean
    // i.e. "true" = true, undefined = true, false = false, "false" = false, "foobar" = true
    if (typeof _value === "boolean") {
        return _value;
    } else if (typeof _value === "string") {
        switch (_value.toLowerCase().trim()) {
            case "false": case "no": case "0": case null: return false;
            case "true": case "yes": case "1": return true;
        }
        // if we still don't have a boolean and the string is not empty return true
        if (typeof _value !== "boolean" && _value.length > 0) {
            return true;
        }
    }
    // if nothing could be evaluate return default
    return _default;
}

export function humanFileSize(bytes, si = false, dp = 1) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

    return bytes.toFixed(dp) + ' ' + units[u];
}


export function filterObjects(objects, search, fields, mode = "includes") {

    console.log("mode", mode);

    const searchToRegex = (searchStr) => {
        //eslint-disable-next-line
        let escapeRegex = (str) => str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1").toLowerCase();
        if (mode === "wildcard" && searchStr) {
            return new RegExp("^" + searchStr.split("*").map(escapeRegex).join(".*") + "$");
        } else {
            return new RegExp(".*" + escapeRegex(searchStr) + ".*");
        }
    }
    console.log("objects", objects);
    if (!objects) {
        console.log("object undefined")
        return [];
    }
    // return early
    if ((!Array.isArray(objects) && objects.length < 1) || !fields || !search) {
        console.log("early leave")
        return objects
    }

    let searchRegex = searchToRegex(search);
    console.log("search", searchRegex);

    const searchMatch = (searchTerm) => {
        return searchRegex.test(searchTerm.toLowerCase())
    }

    if (fields === "*") {
        // add all the keys an object contains to the list
        fields = Object.keys(objects[0]);
    }
    if (!Array.isArray(fields)) {
        // fields is not an array, transfrom it into an array of 1 item
        fields = [fields];
    }
    console.log("fields", fields);

    // filter object
    return objects.filter(object => {
        // iterate on each passed object
        let valueFoundInField = [];
        let hasOneBoolean = function (b) {
            return b === true;
        };
        // field is an array and we are looking for all those fields in the passed objects
        fields.forEach(field => {
            // look for the searh term in the current object in the current field
            console.log(object[field]);
            console.log(searchMatch(object[field]));
            valueFoundInField.push(searchMatch(object[field])
            );
        });
        return valueFoundInField.some(hasOneBoolean);
    });

}

export function filterDisplay(object, fields, format) {
    // object: raw object
    // fields: one string or array of fields we want to return from the given object
    // format: a template string that apply the format on the selected fields passed
    // console.log("filterDisplay", object, fields, format)
    if (!format) {
        format = "${0}";
    }
    // load from comma separated value
    if (typeof (fields) === "string" && fields.includes(",")) {
        fields = fields.split(",");
    }
    // console.log(fields)
    // fields contains a list of field
    if (Array.isArray(fields)) {
        const filtered = [];
        fields.forEach((field) => {
            // check the field exist in the object
            if (field in object) {
                let fieldVal = object[field];
                if (fieldVal) {
                    filtered.push(fieldVal);
                } else {
                    if (object) {
                        if (typeof object === "object" && object.constructor === Object) {
                            filtered.push("");
                        } else {
                            filtered.push(object);
                        }
                    } else {
                        filtered.push("");
                    }
                }
            } else {
                filtered.push("");
            }

        });
        //return filtered
        filtered.forEach((value, index) => {
            format = format.replace("${" + index + "}", value);
        });
        return format;
    } else if (fields && fields !== "*") {
        if (typeof object === "object" && object.constructor === Object) {
            if (fields in object) {
                if (object[fields]) {
                    return object[fields]
                } else {
                    return object;
                }
            }
        } else {
            return object;
        }
    }
    return object;
}

export function objectToFormatedString(object, fields, format) {
    // object: raw object i.e. {"system_name": "SW0001", "client_name": "Main switch"}
    // fields: one string or array of fields we want to return from the given object, can be empty or '*' /!\ order is important i.e. "client_name,system_name"
    // format: a template string that apply the format on the selected fields passed, index number is taken from the fields parameter i.e. "<b>Name: ${0}</b><br>System: ${1}"
    // result: <b>Name: Main switch</b><br>System: SW0001
    if (object) {
        if (typeof (object) === "object" && object.constructor === Object) {
            if (Object.keys(object).length > 0) {

                // no fields passed will assume we take the first key of the object
                if (!fields) {
                    fields = [Object.keys(object)[0]];
                }
                // if a wildcard symbol is passed we take over all the object keys
                if (fields === "*") {
                    fields = Object.keys(object);
                }

                if (typeof (fields) === "string") {
                    fields = fields.split(",").map(val => val.trim());
                }
                // fields should always be an array at this stage 
                if (Array.isArray(fields)) {
                    // console.log("fields", fields);
                    // map each field to it's value if it exists
                    let values = fields.map(field => {
                        if (field in object) {
                            return object[field];
                        } else {
                            return "";
                        }
                    });
                    // console.log("values",values);
                    // if no formating string was passed we'll assume we want to print all value
                    if (!format) {
                        format = values.reduce((acc, cur, index) => {
                            if (cur) {
                                return acc += "${" + index + "} - ";
                            }
                            return acc;
                        }, "");
                        // remove last ' - '
                        format = format.slice(0, -3);
                    }
                    // console.log("format", format);
                    values.forEach((value, index) => {
                        format = format.replace("${" + index + "}", value);
                    });
                    // console.log("result", format);

                    return format;
                } else {
                    console.error("error with provided fields", fields, "type", typeof (fields), "not supported, only string or array");
                    return "";
                }
            } else {
                return "";
            }
        } else {
            // if no actuall object was passed then directly return the value
            return object;
        }
    } else {
        return ""
    }
}